var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIcon)?_c('f7-link',{staticClass:"panel-open",class:_vm.$style.button,attrs:{"open-panel":"left","icon":"far fa-bars"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }